import { FormTypeGeneratedEntity } from "./generated/FormTypeGeneratedEntity";

export abstract class FormTypeEntity extends FormTypeGeneratedEntity {
    // Comment to preserve new line
}
